// Option structure: {name, value, active, hasProducts}

function Category(displayName, dataPoint, checkboxOrderBy, orderByDirection, type, collapsed = false, options = []) {
    this.displayName = displayName;
    this.dataPoint = dataPoint;
    this.checkboxOrderBy = checkboxOrderBy;
    this.orderByDirection = orderByDirection;
    this.type = type.name;
    this.options = options;
    this.collapsed = collapsed;
    this.meta = {};
    this.addOption = function(option) {
        if (!this.options.some(op => op.name === option.name)) {
            this.options.push(option);
        }
    }
    this.getOptionByName = function(name) {
        for (let i = 0; i < this.options.length; i++) {
            let option = this.options[i];
            if (option.name === name) return this.options[i];
        }
    }
    this.addMeta = function(key, value) {
        Object.defineProperty(this.meta, key, {value: value});
    }

    this.element = type.element;
    this.buildOptions = type.buildOptions;
    this.productPassesFilter = type.productPassesFilter;
    this.hasProductsTransform = type.hasProductsTransform;
    this.activeOptionsList = type.activeOptionsList;
    this.activeOptionPills = type.activeOptionsPills;
}

export default Category;